import React from 'react';
import PropTypes from 'prop-types';
import { PersonFillIcon } from '../../model/icons';

// Список участников команды (.mem-grid) с открытием карточки игрока.
export default function MembersGrid({ students, color, onSelect }) {
    return (
        <>
            <div className="tm-mhead">
                <h2>Участники</h2>
                <span className="tm-count">{students.length}</span>
            </div>
            {students.length > 0 ? (
                <div className="mem-grid">
                    {students.map(student => (
                        <button type="button" key={student.id} className="mem" onClick={() => onSelect(student)}>
                            <span className="av" style={{ background: color }}><PersonFillIcon /></span>
                            <div>
                                <div className="mn">{student.surname} {student.name}</div>
                                {student.roomNumber && <div className="mr">Комната {student.roomNumber}</div>}
                            </div>
                        </button>
                    ))}
                </div>
            ) : (
                <div className="t-caption">В команде пока нет участников</div>
            )}
        </>
    );
}

MembersGrid.propTypes = {
    students: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        name: PropTypes.string,
        surname: PropTypes.string,
        roomNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })).isRequired,
    color: PropTypes.string,
    onSelect: PropTypes.func.isRequired
};

MembersGrid.defaultProps = { color: 'var(--navy)' };
